<template>
  <div
    class="row match-header flex-center-vertical">
    <div
      class="vertical-line"
      :class="`sport-color-${idSport}`"
    />
    <p class="match-display-id text-center">
      {{ idDisplay }}
    </p>
    <i
      class="match-header-icon n-i"
      :class="`n-i-live-${idSport}`"
    />
    <span class="tournament-name text-cut">
      {{ tournamentName }}
    </span>
    <span class="filler" />
    <span class="period-time font-bold">
      {{ periodTime }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'MatchHeader',
  props: {
    idSport: {
      required: true,
      type: Number,
    },
    idDisplay: {
      required: true,
      type: Number,
    },
    idTournament: {
      required: true,
      type: Number,
    },
    periodTime: {
      required: false,
      type: String,
      default: '',
    },
  },
  computed: {
    tournamentName() {
      return this.$store.getters.getTournamentName(this.idTournament);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-header {
  padding-right: 20px;
  color: $color-text-primary;
  @if $sport-header-gradient == false {
    background-color: $sport-header-color-back;
  } @else {
    background-image: $sport-header-color-back-gradient;
  }
}

.vertical-line {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: $match-vertical-line-width;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 1;
}

.match-display-id {
  float: left;
  width: $match-display-id-width;
  height: 100%;
  padding-left: $match-vertical-line-width;
  background-color: $match-id-color-back;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  font-weight: $font-weight-bold;
  font-size: 0.875rem;
}

.match-header-icon {
  padding-left: 10px;
  font-size: 0.8125rem;
}

.tournament-name {
  padding-left: 10px;
}

.period-time {
  color: $color-important;
}
</style>
